import { Navigate, Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { useUser } from "../context/UserContext";
import Loader from "../components/ui/Loader";

interface RoleGuardProps {
  allowedRoles: string[];
}

export default function RoleGuard({ allowedRoles }: RoleGuardProps) {
  const { user, loading } = useUser();
  const [isAllowed, setIsAllowed] = useState<boolean | null>(null);

  useEffect(() => {
    if (loading) return;
    if (!user) {
      setIsAllowed(false);
      return;
    }

    const hasAccess = allowedRoles.includes(user.typeLabel ?? "");
    setIsAllowed(hasAccess);
  }, [allowedRoles, user, loading]);

  if (loading || isAllowed === null)
    return <Loader text="Verifying access..." />;

  return isAllowed ? (
    <Outlet />
  ) : (
    <Navigate
      to="/error?message=Não tem permissão para aceder a esta página.&errorCode=403"
      replace
    />
  );
}
